exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput.vue-pincode-input[data-v-334655f8] {\n    margin: 3px;\n    padding: 5px;\n    max-width: 40px;\n    text-align: center;\n    font-size: 1.1rem;\n    border: 1px solid #ced4da;\n    border-radius: 0.25rem;\n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    box-shadow: none;\n}\ninput.vue-pincode-input[data-v-334655f8]:focus {\n    background-color: #fff;\n    border-color: #249eef;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(10, 87, 138, 0.25);\n}\n", ""]);

// exports
